import { ActualizePriceResponse } from '../services/primary-actualization';
import { ActualizationData } from '../models/actualization';


// TODO selkin: эту обёртку нужно вынести в api-services, ибо без неё не удобно, но она здесь и не должна быть
export function extractActualizationData(response: ActualizePriceResponse): ActualizationData {
    const kidsAges: number[] = [];
    return {
        tour: response.tour || null,
        oilTaxes: response.getOilTaxes(kidsAges),
        visaFees: response.getVisaFees(kidsAges),
        isDetailedExists: response.isDetailedExists,
        originTourId: !!response.tour ? response.tour.sletatTourId : null,
        originTourPrice: !!response.tour ? response.tour.price : null,
        resourceData: response.resourceData || [],
        resources: response.resources || [],
        services: response.services
    };
}
